'use client';

import { useState } from 'react';
import Icon from '@/components/ui/AppIcon';

interface SearchBarProps {
  onSearch: (query: string) => void;
}

export default function SearchBar({ onSearch }: SearchBarProps) {
  const [searchQuery, setSearchQuery] = useState('');

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    onSearch(searchQuery);
  };

  const handleClear = () => {
    setSearchQuery('');
    onSearch('');
  };

  return (
    <form data-component-id="src/app/technical-resources/components/SearchBar.tsx:24:4" data-component-path="src/app/technical-resources/components/SearchBar.tsx" data-component-line="24" data-component-end-line="46" data-component-file="SearchBar.tsx" data-component-name="form" data-component-content="%7B%22elementName%22%3A%22form%22%2C%22className%22%3A%22relative%22%7D" onSubmit={handleSearch} className="relative">
      <input data-component-id="src/app/technical-resources/components/SearchBar.tsx:25:6" data-component-path="src/app/technical-resources/components/SearchBar.tsx" data-component-line="25" data-component-end-line="31" data-component-file="SearchBar.tsx" data-component-name="input" data-component-content="%7B%22elementName%22%3A%22input%22%2C%22type%22%3A%22text%22%2C%22value%22%3A%22%5Bvar%3AsearchQuery%5D%22%2C%22className%22%3A%22w-full%20px-4%20py-3%20pl-12%20pr-12%20bg-white%20border%20border-border%20rounded-lg%20text-sm%20focus%3Aoutline-none%20focus%3Aring-2%20focus%3Aring-primary%22%7D"
        type="text"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        placeholder="Search technical resources, white papers, guides..."
        className="w-full px-4 py-3 pl-12 pr-12 bg-white border border-border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-primary"
      />
      <Icon data-component-id="src/app/technical-resources/components/SearchBar.tsx:32:6" data-component-path="src/app/technical-resources/components/SearchBar.tsx" data-component-line="32" data-component-end-line="36" data-component-file="SearchBar.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22MagnifyingGlassIcon%22%2C%22className%22%3A%22absolute%20left-4%20top-1%2F2%20-translate-y-1%2F2%20text-text-secondary%22%7D"
        name="MagnifyingGlassIcon"
        size={20}
        className="absolute left-4 top-1/2 -translate-y-1/2 text-text-secondary"
      />
      {searchQuery && (
        <button data-component-id="src/app/technical-resources/components/SearchBar.tsx:38:8" data-component-path="src/app/technical-resources/components/SearchBar.tsx" data-component-line="38" data-component-end-line="44" data-component-file="SearchBar.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22type%22%3A%22button%22%2C%22className%22%3A%22absolute%20right-4%20top-1%2F2%20-translate-y-1%2F2%20text-text-secondary%20hover%3Atext-text-primary%22%7D"
          type="button"
          onClick={handleClear}
          className="absolute right-4 top-1/2 -translate-y-1/2 text-text-secondary hover:text-text-primary"
        >
          <Icon data-component-id="src/app/technical-resources/components/SearchBar.tsx:43:10" data-component-path="src/app/technical-resources/components/SearchBar.tsx" data-component-line="43" data-component-end-line="43" data-component-file="SearchBar.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22XMarkIcon%22%7D" name="XMarkIcon" size={20} />
        </button>
      )}
    </form>
  );
}
